import { render, staticRenderFns } from "./POSDesktop.vue?vue&type=template&id=3f20882b&scoped=true"
import script from "./POSDesktop.vue?vue&type=script&lang=js"
export * from "./POSDesktop.vue?vue&type=script&lang=js"
import style0 from "./POSDesktop.vue?vue&type=style&index=0&id=3f20882b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f20882b",
  null
  
)

export default component.exports